module.exports = __webpack_public_path__ + "img/valid_icon.70712df9.svg";